<template>
  <title>Work Order Request Form</title>
  <body>
    <div id="body" name="body">
      <div class="header">
        <div class="title">
          <h2>Work Order Request Form</h2>
        </div>
        <div class="subtitle">
          <h5 :company="company" :sortCode="sortCode">{{ company }} ({{ sortCode }})</h5>
        </div>
      </div>
      <div style="clear:both"></div>
      <div  v-if="!orderSubmitted" id="requestForm" name="requestForm" class="requestForm">
        <form method="post" name="fp_WorkOrderRequestForm" id="fp_WorkOrderRequestForm" class="submitForm">
            <div id="newRequestLabel" name="newRequestLabel" class="label">
              <h4 style="margin-bottom: 0px; margin-left: 3%">New Request</h4>
            </div>
            <div id="requiredLabel" name="requiredLabel" class="error"></div>
            <!--Create requestor value list if necessary-->
            <div>
             <label for="requestor">Requestor*</label>
            </div>
            <div v-if="custWebSite == 1 && requesters">
                <select name="requestor" id="requestor" class="standard" v-model="requestor">
                    <option v-for="(requester, i) in requesters" :key="i" :value="requester.fieldData.Requester">{{ requester.fieldData.Requester }}</option>
                </select>
            </div>
            <div v-else>
                 <input type="text" name="requestor" id="requestor" class="standard" v-model="requestor" />
            </div>
            <div style="clear:both"></div>
            <!--Create branch value list if necessary-->
            <div>
              <label for="branch">Branch</label>
            </div>
            <!-- <br> -->
            <div v-if="custWebSite == 1 && branches">
                <select name="branch" id="branch" class="standard" v-model="branch">
                    <option v-for="(branch, i) in branches" :key="i" :value="branch.fieldData.WKSHT">{{ branch.fieldData.WKSHT }}</option>
                </select>
            </div>
            <div v-else>
                 <input type="text" name="branch" id="branch" class="standard" v-model="branch" />
            </div>
            <div>
              <label for="lastName" style="width: 40%">Applicant Last Name</label><label for="firstName" style="width: 40%; margin-left: 2%; margin-right: 0px">Applicant First Name</label>
            </div>
            <div>
              <input type="text" name="lastName" id="lastName" class="standard" style="width: 44%; margin-right: 0px" v-model="lastName" />
              <input type="text" name="firstName" id="firstName" class="standard" style="width: 45%; margin-right: 0px; margin-left: 1%" v-model="firstName" />
            </div>
            <!--<div>
              <label for="firstName">Applicant First Name</label>
            </div>-->
            <!--<div>
              <input type="text" name="firstName" id="firstName" class="standard"></input>
            </div>-->
            <div>
              <label for="propertyAddress">Property Address*</label>
            </div>
            <div>
              <input type="text" name="propertyAddress" id="propertyAddress" class="standard" v-model="propertyAddress" />
            </div>
            <div>
              <label for="city" style="width: 55%">City*</label><label for="state" style="width:10%; margin-left: 3%; margin-right: 0px">State*</label><label for="zip" style="width:10%; margin-left: 1%">Zip*</label>
            </div>

            <div>
              <input type="text" name="city" id="city" class="standard" style="width: 60%; margin-right: 0px" v-model="city" />
              <input type="text" name="state" id="state" class="standard" style="width: 10%; margin-right: 0px; margin-left: 1%" v-model="state" />
              <input type="text" name="zip" id="zip" class="standard" style="width: 18%; margin-right: 0px; margin-left: 1%" v-model="zip" />
            </div>
            <!--<div>
              <label for="state">State*</label><br>
              <input type="text" name="state" id="state" class="standard"></input>
            </div> -->
            <!--<div>
              <label for="zip">Zip*</label>
            </div>
            <div>
              <input type="text" name="zip" id="zip" class="standard"></input>
            </div> -->
            <div>
              <label for="parcelNumber">Parcel Number</label>
            </div>
            <div>
              <input type="text" name="parcelNumber" id="parcelNumber" class="standard" v-model="parcelNumber"/>
            </div>
            <!--PURPOSE OF LOAN-->
            <div>
              <label for="purposeOfLoan">Purpose of Loan</label>
            </div>
            <!-- <br> -->
            <div>
                <select name="purposeOfLoan" id="purposeOfLoan" class="standard" v-model="purposeOfLoan">
                    <option v-for="(purpose, i) in purposeOptions" :key="i">{{ purpose }}</option>
                </select>
            </div>
            <div>
              <label for="commentsLegal">Comments/Legal</label>
            </div>
            <div>
              <textarea name="commentsLegal" id="commentsLegal" class="standard" style="min-height: 64px; margin-left: 4%" v-model="commentsLegal"></textarea>
            </div>
            <div>
              <label for="additionalLastName" style="width: 40%">Additional Last Name</label><label for="additionalFirstName" style="width: 40%; margin-left: 2%; margin-right: 0px">Additional First Name</label>
            </div>
            <div>
              <input type="text" name="additionalLastName" id="additionalLastName" class="standard" style="width: 44%; margin-right: 0px" v-model="additionalLastName" />
              <input type="text" name="additionalFirstName" id="additionalFirstName" class="standard" style="width: 45%; margin-right: 0px; margin-left: 1%" v-model="additionalFirstName" />
            </div>
            <div>
              <label for="loanNumber">Loan Number</label>
            </div>
            <div>
              <input type="text" name="loanNumber" id="loanNumber" class="standard" v-model="loanNumber" />
            </div>
             <!-- Start File Upload -->
            <div>
              <label for="fileUpload">Upload Files (3 max.)</label>
            </div>
            <div class="flex flex-col">
              <label for="FileUpload" class="mx-auto">
                <div class="button cursor-pointer ml-5 mr-7"> 
                  {{ files.length }} files were chosen
                </div>
                <input @change="fileUpload($event)" ref="inputFile" type="file" id="FileUpload" name="upload" multiple="multiple"  accept=".pdf, .doc, .docx, .jpg, .jpeg, .png, text/rtf, text/plain, .xls, .xlsx" class="standard bg-white hidden rounded-md">          
              </label>
              <div class="mt-1" v-for="(file, i) in files" :key="i">
                  <tw-filepanel :file="file" @remove-file="removeFile" class="ml-5 mr-7 my-2"></tw-filepanel>
              </div>       
              <label class="py-2">Approved file types:<br>pdf, doc, docx, jpg, jpeg, png, rtf, txt, xls, xlsx</label>
            </div>
            <div v-show="isLoading" class="pleaseWait text-gray-600">
              Please wait...
            </div>
            <!-- End File Upload -->
            <div>
              <button :disabled="hasSubmitted" type="button" id="btnSubmit" name="btnSubmit" style="width: 90%; height: 50px" :class="(hasSubmitted ? 'cursor-default' : 'cursor-pointer')" @click="onSubmit">Submit</button>
            </div>
        </form>
      </div>

      <div v-if="!orderSubmitted" id="ordersAndFind" name="ordersAndFind" class="ordersAndFind">
        <div id="lastOrders" name="lastOrders" class="lastOrders">
          <div class="label">
            <h4 style="margin-bottom: 0px; margin-left: 3%">Recent Orders (Last {{ recentOrders.length }} Shown)</h4>
          </div>


          <table class="table-auto" style="margin:0px">
            <thead>
                <tr style="background-color: RGB(170, 170, 170)">
                    <td class="label" style='border-right: 0px; border-left: 0px; text-align: left'>Name</td>
                    <td class="label" style='border-right: 0px; border-left: 0px; text-align: left'>Flood Zone</td>
                    <td class="label" style='border-right: 0px; border-left: 0px; text-align: left'>Address</td>
                    <td class="label" style='border-left: 0px; text-align: left'>Cert</td>
                    <td class="label" style='border-left: 0px; text-align: left'>Map</td>
                    <td class="label" style='border-left: 0px; text-align: left'>Kit</td>
                </tr>
            </thead>
            <tbody class="border-2">
              <tr v-for="order in recentOrders" :key="order" style='border: solid RGB(210, 210, 210) 2px;'>
                  <td v-for="(item, index) in order" :key="index" class="text-sm" style="border-right: 2px; border-left: 2px" v-html="item">
                  </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="orderSubmitted" id="requestForm" name="requestForm" class="requestForm w-1/2">
        <div class="submitForm">
          <div class="label">
            <h4 style="margin-bottom: 0px; margin-left: 3%">Request Submitted</h4>
          </div>
          <div class="text-sm">
            <div class="text-red-500 px-2 py-1 font-bold">Successfully Sent {{ submittedData.SentToFCI }} FCI#:{{ submittedData.zgtFCINum }} </div>
            <div class="submittedLine"></div>

            <div class='submitted'>Requestor: <b>{{ submittedData.Requestor }}</b></div>
            <div class='submitted'>Property Address: <b>{{ submittedData.Prop_Address }}</b></div>
            <div class='submitted'>City: <b>{{ submittedData.Prop_City }}</b></div>
            <div class='submitted'>State: <b>{{ submittedData.Prop_State }}</b></div>
            <div class='submitted'>Zip: <b>{{ submittedData.Prop_Zip }}</b></div>
            <div class='submitted'>Branch: <b>{{ submittedData.Branch }}</b></div>
            <div class='submitted'>Applicant Last Name: <b>{{ submittedData.Prop_Applicant_Last }}</b></div>
            <div class='submitted'>Applicant First Name: <b>{{ submittedData.Prop_Applicant_First }}</b></div>
            <div class='submitted'>Additional Last Name: <b>{{ submittedData['#1_Last'] }}</b></div>
            <div class='submitted'>Additional First Name: <b>{{ submittedData['#1_First'] }}</b></div>
            <div class='submitted'>Loan Number: <b>{{ submittedData.Loan_ID }}</b></div>
            <div class='submitted'>Parcel Number: <b>{{ submittedData.Parcel_Number }}</b></div>
            <div class='submitted'>Purpose of Loan: <b>{{ submittedData['Purpose of Loan']}}</b></div>
            <div class='submitted'>Comments/Legal: <b>{{ submittedData['Short Legal Descript']}}</b></div>

            <div id='submitMessage' name='submitMessage' class='submitted font-bold' style='width: 100%; text-align: center'>
              <h4 style='color:red; margin-bottom: 10px'>Print This For Your Records.</h4>Send Additional Information and/or Request Changes to:<br>
              Fax No. (317) 858-4421, Phone No. (800) 945-0246, floodplain@floodplain.com<br>
              Please Provide FCI# When Contacting Us. Thank you!
            </div>

          </div>
        </div>
      </div>
    </div>
    <div id="errorSubmit" class="required"></div>
    <div type="hidden" id="pleaseWait" name="pleaseWait"></div>
    <div type="hidden" id="submitSuccess" name="submitSuccess" style="display:none">
      <form type="hidden" method="post" action="print-request"  class="successfulSubmit" name="printForm" id="printForm" target="_blank">
        <div class='label'>
          <h4 style='margin-bottom: 0px'>Request Submitted</h4>
        </div>
        <div type="hidden" name="formHasBeenSubmitted" id="formHasBeenSubmitted"><div v-html="successMessage"></div></div>
      </form>
    </div>
  </body>
</template>

<script>
    import { defineComponent, ref } from 'vue'
    import sharedAPI from '@/api/SharedAPI.js'
    import { useStore } from 'vuex'

    export default defineComponent({
        name: 'Dashboard',
        setup() {
          const store = useStore()
          const lastName = ref('')
          const firstName = ref('')
          const propertyAddress = ref('')
          const city = ref('')
          const state = ref('')
          const zip = ref('')
          const parcelNumber = ref('')
          const commentsLegal = ref('')
          const additionalLastName = ref('')
          const additionalFirstName = ref('')
          const loanNumber = ref('')
          const requestor = ref('')
          const branch = ref('')
          const documentNames = ref('')
          const documentURLs = ref('')
          const company = store.state.user.company
          const sortCode = store.state.user.sortCode
          const custWebSite = store.state.user.valueListFlag
          const purposeOfLoan = ref('')
          const isLoading = ref(false)
          const orderSubmitted = ref(false)
          const requesters = ref([])
          const branches = ref([])
          const successMessage = ref('')
          const hasSubmitted = ref(false)

          //Options for purpose of loan select menu 
          const purposeOptions = ref([
            'Purchase',
            'Refinance',
            'New Construction',
            'Room Addition',
            'Land Only',
            'Other (Please explain in comments section below)',
          ])

          //Function that gets 10 most recent recent orders 
          const isResultError = ref(false)
          const isNoActivity = ref(false)
          const currentDate = new Date().toLocaleDateString()
          const beginDate = new Date(new Date() - (60*60*24*60*1000)).toLocaleDateString()
          const dateRange = `${beginDate}...${currentDate}`
          const data = {
            query: [
              {
                "LL_Login_Date": dateRange,
                "Client": `=="${store.state.user.company}"`
              }
            ],
            sort: [
              {
                "fieldName": "SentToFCI",
                "sortOrder": "descend"
              }
            ],
            "limit": 10,
            "offset": 1,
          };

          const responseData = ref([])
          const recentOrders = ref([]);

          // fillRecentOrders();
          //need v-for to loop through response and display all recent orders
          (async () => {
            const layout = "Web%20-%20FCI_Database";
            responseData.value = (await sharedAPI.find(data, layout));
            responseData.value = responseData.value.data.response.data;

            //Map needed fields to new array for displaying
            recentOrders.value = responseData.value.map(order => {
              const fullName = order.fieldData['Prop_Applicant_Last'] + ', ' + order.fieldData['Prop_Applicant_First'];
              const floodZone = order.fieldData['FCI_Zone'];
              const address = order.fieldData['Prop_Address'] + '<br/>' +  order.fieldData['Prop_City'] + ', ' + order.fieldData['Prop_State'] + ', ' + order.fieldData['Prop_Zip'];
              var cert = order.fieldData['TAGField']
              if (cert == 1){
                cert = "<a href='https://www.floodplain.com/fcipdf/FLOODCERT"+order.fieldData['FCI#']+".pdf' target='_blank'><img src='/online/pdfImage.jpeg' height='25' width='25'></img></a>";
              }
              var map = order.fieldData['mapAvailable']
              if (map == 1){
                map = "<a href='https://www.floodplain.com/fcimap/map"+order.fieldData['FCI#']+".pdf' target='_blank'><img src='/online/pdfImage.jpeg' height='25' width='25'></img></a>";
              }
              var kit = order.fieldData['zoneAAvailable']
              if (kit == 1){
                kit = "<a href='https://www.floodplain.com/fcikit/KIT"+order.fieldData['FCI#']+".pdf' target='_blank'><img src='/online/pdfImage.jpeg' height='25' width='25'></img></a>";
              }
              return [
                fullName,
                floodZone,
                address,
                cert,
                map,
                kit,
              ]
            })
            try {
              const requesterFindData = {
                query: [
                  {
                    "SortCode": sortCode
                  }
                ],
                sort: [
                  {
                    "fieldName": "Requester",
                    "sortOrder": "ascend"
                  }
                ],
                "limit": 10000
              };
              requesters.value = (await sharedAPI.find(requesterFindData, 'Web%20-%20RequesterDB')).data.response.data;
              if (custWebSite == 1){
                requestor.value = requesters.value[0].fieldData.Requester
              }

              //Get branches for select options
              const branchFindData = {
                query: [
                  {
                    "SortCode": sortCode
                  }
                ],
                sort: [
                  {
                    "fieldName": "sortCode",
                    "sortOrder": "ascend"
                  }
                ],
                "limit": 10000
              };
              branches.value = (await sharedAPI.find(branchFindData, 'Web%20-%20BranchDB')).data.response.data;
              if (custWebSite == 1 && branches.value){
                branch.value = branches.value[0].fieldData.WKSHT
              }
            }catch(e){
              console.log(e)
            }
          })()


          //Function that sends form data to FM script
          const submittedData = ref(null)
          async function onSubmit() {
            console.log('In onSubmit')
            isLoading.value = true
            hasSubmitted.value = true
            //Build documentNames and documentUrls using uploaded files
            for (const i in files.value){
              const documentName = files.value[i].name
              var documentURL =  await getBase64(files.value[i])
              documentURL = (documentURL.split(','))[1]

              if (documentNames.value == ''){
                documentNames.value = documentName
              }else{
                documentNames.value = documentNames.value + ',' + documentName
              }

              if (documentURLs.value == ''){
                documentURLs.value = documentURL
              }else{
                documentURLs.value = documentURLs.value + ',' + documentURL
              }
            }

            const scriptParameters = `requestor == ${requestor.value}<br>company == ${store.state.user.company}<br>branch == ${branch.value}<br>applicantLastName == ${lastName.value}<br>applicantFirstName == ${firstName.value}<br>propertyAddress == ${propertyAddress.value}<br>city == ${city.value}<br>state == ${state.value}<br>zip == ${zip.value}<br>parcelNumber == ${parcelNumber.value}<br>purposeOfLoan == ${purposeOfLoan.value}<br>commentsLegal == ${commentsLegal.value}<br>additionalLastName == ${additionalLastName.value}<br>additionalFirstName == ${additionalFirstName.value}<br>loanNumber == ${loanNumber.value}<br>documentNames == ${documentNames.value}<br>documentURLs == ${documentURLs.value}`
              const result = await sharedAPI.runScript("Web - Submit Work Order Request", scriptParameters)
              console.log(result)
              submittedData.value = result.record.response.data[0].fieldData

              //Check if there are errors with submiting form in FileMaker
              //If so send email reporting the error
              if (result.error.errorCode != 0){
                const postData = {
                    fieldData : {
                    },
                    errMesage : result.error.errMesage,
                    parameters : scriptParameters,
                }
                await sharedAPI.errorEmail(postData)
              }

              //Log response
              const postData = {
                    fieldData : {
                    },
                    errMesage : result.error.errMesage,
                    requestor : requestor.value,
                    company : company.value,
                    branch : branch.value,
                    applicantLastName : lastName.value,
                    applicantFirstName : firstName.value,
                    propertyAddress : propertyAddress.value,
                    city : city.value,
                    state : state.value,
                    zip : zip.value,
                    parcelNumber : parcelNumber.value,
                    purposeOfLoan : purposeOfLoan.value,
                    commentsLegal : commentsLegal.value,
                    additionalLastName : additionalLastName.value,
                    additionalFirstName : additionalFirstName.value,
                    loanNumber : loanNumber.value,
                    documentsNames : documentNames.value,
                    documentsURLs : documentURLs.value,
              }

              await sharedAPI.log(postData)

              isLoading.value = false
              orderSubmitted.value = true
              
          }  
          
          const files = ref([])

          //Add file to list of files to upload
          async function fileUpload (e){
            try {
              var filesTemp = e.target.files || e.dataTransfer.files
              filesTemp = Array.from(filesTemp)

              //Throw error message if there are more than 3 files 
              if (((files.value).concat(filesTemp)).length > 3){
                confirm("Only 3 files are allowed to be uploaded.")
                return
              }

              for(const i in filesTemp){
                if (filesTemp[i].type == 'text/csv'){
                  alert("Only the file types listed below are allowed to be uploaded.")
                  this.$refs.inputFile.value = null
                  return
                }
              }
              
              files.value = (files.value).concat(filesTemp)
              this.$refs.inputFile.value = null
            } catch (err){
              console.log(err)
            }
          }

          //Remove file from current list of files
          function removeFile (e){
            if (confirm("Are you sure you want to remove this file?")){
              if (files.value.indexOf(e) != -1){
                files.value.splice(files.value.indexOf(e), 1)
              } else {
                return
              }
            }
          }

          //Convert file to base64 to store correctly in the DB
          function getBase64(file) {
            return new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = () => resolve(reader.result);
              reader.onerror = error => reject(error);
            });
          }

          return {
            lastName,
            firstName,
            propertyAddress,
            city,
            state,
            zip,
            parcelNumber,
            commentsLegal,
            additionalLastName,
            additionalFirstName,
            loanNumber,
            isLoading,
            requestor,
            branch,
            documentNames,
            documentURLs,
            company,
            onSubmit,
            responseData,
            isResultError,
            isNoActivity,
            sortCode,
            recentOrders,
            orderSubmitted,
            submittedData,
            requesters,
            branches,
            fileUpload,
            removeFile,
            files,
            purposeOptions,
            purposeOfLoan,
            custWebSite,
            successMessage,
            hasSubmitted
          }
        }
    })
</script>

<style scoped>
    tbody tr:nth-child(odd){
        background-color: RGB(230, 230, 230);
    }

    div.submitForm{
      background-color: RGB(240, 240, 240) !important;
      width: 88% !important;
      min-height:100% !important;
      border: solid RGB(210, 210, 210) 1px !important;
      border-top: 0px !important;
      margin: 0px !important;
      overflow: hidden !important;
    }

    .button {
      font: bold 11px Arial;
      text-decoration: none;
      background-color: rgb(254, 254, 254);
      color: rgb(136, 136, 136);
      padding: 10px 10px 10px 10px;
      border-top: 2px solid #e2e2e2;
      border-right: 1px solid #71717a;
      border-bottom: 1px solid #71717a;
      border-left: 2px solid #e2e2e2;
      border-top-style: inset;
      border-left-style: inset;
      border-radius: 3px;
    }

    div.pleaseWait{
      width: 80%;
      margin-left: 10%;
      margin-right: 10%;
      font-weight: bold;
    }
</style>